<template>
  <v-card>
    <v-card-title v-if="mockup || disclaimer.title">
      <template v-if="mockup">
        {{ disclaimer.title ?? 'TITLE HERE' }}
      </template>
      <template v-else>
        {{ disclaimer.title }}
      </template>
    </v-card-title>
    <v-card-text>
      {{ disclaimer.content ?? 'CONTENT HERE' }}
    </v-card-text>
    <v-card-actions class="d-flex justify-space-between">
      <v-btn @click.prevent="close">
        {{ disclaimer.close_button ?? 'Close' }}
      </v-btn>

      <v-btn color="primary"
             @click.prevent="open">
        {{ disclaimer.open_button ?? 'I acknowledge, proceed' }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  props: {
    disclaimer: {
      type: Object,
      required: true,
    },
    mockup: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    open() {
      this.$emit('open');
    }
  }
}
</script>
